var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isInviteUrl? 'invite-iframe':'decline-iframe'},[_c('iframe',{staticClass:"w-full h-full border-0",attrs:{"src":("https://" + _vm.queryUrl)}})])}
var staticRenderFns = []

export { render, staticRenderFns }